import React, { useCallback } from 'react';
import { useSend } from '@sc1/common/hooks';
import {
  getHarvestParams,
  fromNow,
  strategies,
  useSearchParam,
  IChain,
  useStrategySubgraph,
  HedgedLP,
} from '@sc1/common';
import { Card, Text, Heading, Row } from '../core';
import { StatusButton } from '../StatusButton';
import type { CardProps } from 'theme-ui';

interface HarvestStrategyProps extends CardProps {
  strategy: HedgedLP;
  disabled: boolean;
}
export const HarvestStrategy = ({
  strategy,
  disabled,
  sx,
  ...rest
}: HarvestStrategyProps): JSX.Element => {
  const { sendTx, txStatus } = useSend();

  const chain = useSearchParam().get('chain', 'all chains') as IChain;
  const lastHarvest = useStrategySubgraph(chain, strategy?.address)?.data
    ?.strategy?.lastHarvest;

  const harvestStrategy = useCallback(async () => {
    if (!strategy) return;
    const symbol = await strategy.symbol();
    const strat = strategies.find((s) => s.symbol === symbol);
    if (!strat) throw new Error(`Cannot find strategy ${symbol}`);
    const harvestArgs = await getHarvestParams(
      strategy,
      strat,
      strategy.signer,
      undefined,
      true
    );
    sendTx(
      strategy,
      'harvest',
      // TODO: harvestParams to harvestArgs typecheck
      // @ts-ignore
      harvestArgs
    );
  }, [strategy, sendTx]);

  return (
    <Card
      sx={{ flex: 1, display: 'flex', justifyContent: 'flex-start', ...sx }}
      {...rest}
    >
      <Text variant="hint" mb={1}>
        Last Harvested {fromNow(Number(lastHarvest) * 1000)}
      </Text>
      <Heading mb={2} as="h3">
        Harvest Strategy
      </Heading>
      <Row variant="collapse">
        <StatusButton
          disabled={disabled}
          onClick={harvestStrategy}
          status={txStatus}
        >
          Harvest
        </StatusButton>
      </Row>
    </Card>
  );
};
